import { ListingRequestSource } from '@/store/modules/api';

export const formatListingRequest = <T>({
  ordering,
  page,
  limit,
  filters,
  offset,
}: ListingRequestSource<T>) => ({
    o: ordering?.reduce(
      (acc, cur) => {
        acc.push(`${cur.direction === 'asc' ? '' : '-'}${String(cur.key)}`);
        return acc;
      }, [] as string[],
    ) || undefined,
    limit,
    offset: offset ?? (page - 1) * limit,
    page,
    ...filters,
  }) || '';
